// src/util/bem.ts
var makeBEM = function makeBEM(block, element, modifier) {
  return "".concat(block, "-").concat(element).concat(modifier ? "--".concat(modifier) : "");
};
var appendBEMModifier = function appendBEMModifier(blockElement, modifier) {
  return "".concat(blockElement, "--").concat(modifier);
};
var appendBEMModifierOnCondition = function appendBEMModifierOnCondition(blockElement, modifier, condition) {
  return condition ? "".concat(blockElement, "--").concat(modifier) : "";
};
export { makeBEM, appendBEMModifier, appendBEMModifierOnCondition };